import type * as Sentry from '@sentry/react';

export function scrubPii(event: Sentry.ErrorEvent): void {
  if (event.user) {
    delete event.user.email;
    delete event.user.ip_address;
    delete event.user.username;
    delete event.user.geo;
  }

  if (event.request?.url) {
    event.request.url = sanitizeSecretSantaUrl(event.request.url);
  }

  for (const breadcrumb of event.breadcrumbs ?? []) {
    if (breadcrumb.data && typeof breadcrumb.data.url === 'string') {
      breadcrumb.data.url = sanitizeSecretSantaUrl(breadcrumb.data.url);
    }
    if (breadcrumb.data && typeof breadcrumb.data.to === 'string') {
      breadcrumb.data.to = sanitizeSecretSantaUrl(breadcrumb.data.to);
    }
    if (breadcrumb.data && typeof breadcrumb.data.from === 'string') {
      breadcrumb.data.from = sanitizeSecretSantaUrl(breadcrumb.data.from);
    }
  }
}

export function sanitizeSecretSantaUrl(url: string): string {
  return url.replace(/\/s\/[^/?#\s]+/, '/s/[id]');
}
